module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_mobile-faebc4d3a11e25ca38da6aabd0b2d3bd.jpg";